export default __webpack_public_path__ + "abe08bfb287daff370cc13f0013df02d.svg";